import axios from 'axios'
import HTTP from './http'
export default {
    getProducts: role => axios.get(HTTP.PRODUCTS, { params: { role } })
}
